/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// ref: https://ja.reactjs.org/docs/react-api.html#reactforwardref
// > ref を配下のツリーの別のコンポーネントに受け渡す React コンポーネントを作成します
// ------------------------------------------------------------
// Form

/**
 * form - `ref` 必要な form を forwardRef し作成します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - form
 */
export const Form = forwardRef((props, ref) => (
  <form ref={ref} {...props}>
    {props.children}
  </form>
));

// ------------------------------------------------------------
// select - option
/**
 * form - `ref` 必要な select を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Select = forwardRef((props, ref) => (
  <select ref={ref} {...props}>
    {props.children}
  </select>
));

// ------------------------------------------------------------
// TEXTAREA
/**
 * form - `ref` 必要な textarea を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Textarea = forwardRef((props, ref) => (
  <textarea ref={ref} {...props} style={{ wordBreak: 'break-all' }} />
));

// ------------------------------------------------------------
// INPUT
/**
 * form - `ref` 必要な input[type="text"] を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Text = forwardRef((props, ref) => (
  <input
    type={'text'}
    ref={ref}
    {...props}
    style={{ wordBreak: 'break-all' }}
  />
));

/**
 * form - `ref` 必要な button を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Button = forwardRef((props, ref) => (
  <button type={'button'} ref={ref} {...props}>
    <span style={{ wordBreak: 'break-all', display: 'inline-block' }}>
      {props.children}
    </span>
  </button>
));

// /**
//  * form - `ref` 必要な input[type="submit"] を forwardRef し作成します
//  * - basic component として使用します
//  * @param {*} props React.props
//  * @param {*} ref React.refs
//  * @return {*} React.forwardRef - select
//  */
// export const Submit = forwardRef((props, ref) => (
//   <input type={'submit'} ref={ref} {...props} />
// ));

// ---
/**
 * form - `ref` 必要な input[type="checkbox"] を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Checkbox = forwardRef((props, ref) => (
  <input type={'checkbox'} ref={ref} {...props} />
));

/**
 * form - `ref` 必要な input[type="radio"] を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
export const Radio = forwardRef((props, ref) => (
  <input type={'radio'} ref={ref} {...props} />
));

// ---
/**
 * form - `ref` 必要な input を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - select
 */
const Input = forwardRef((props, ref) => <input ref={ref} {...props} />);

export default Input;

// ---
/**
 * a - `ref` 必要な a を forwardRef し作成します
 * - basic component として使用します
 * @param {*} props React.props
 * @param {*} ref React.refs
 * @return {*} React.forwardRef - a
 */
export const A = forwardRef((props, ref) => (
  <a ref={ref} rel="noopener noreferrer" {...props}>
    {props.children}
  </a>
));



// WEBPACK FOOTER //
// ./src/phase2/common/primitive/index.js